import React from 'react';
import { Letter } from '../types/game';
import './GridDebugView.css';

interface GridDebugViewProps {
  previousGrid: Letter[][];
  currentGrid: Letter[][];
  isVisible: boolean;
  onClose: () => void;
}

const GridDebugView: React.FC<GridDebugViewProps> = ({ 
  previousGrid, 
  currentGrid, 
  isVisible,
  onClose
}) => {
  if (!isVisible || previousGrid.length === 0) {
    return null;
  }

  const renderGrid = (grid: Letter[][], title: string) => {
    return (
      <div className="debug-grid-container">
        <h3 className="debug-grid-title">{title}</h3>
        <div className="debug-grid">
          {grid.map((row, rowIndex) => (
            <div key={rowIndex} className="debug-grid-row">
              {row.map((letter, colIndex) => (
                <div
                  key={`${rowIndex}-${colIndex}`}
                  className={`debug-tile ${letter.used ? 'used' : 'unused'} ${letter.char === ' ' ? 'empty' : ''}`}
                >
                  {letter.char === ' ' ? '' : letter.char}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="debug-grid-info">
          Size: {grid.length}x{grid.length} | 
          Used: {grid.flat().filter(l => l.used).length} | 
          Unused: {grid.flat().filter(l => !l.used).length}
        </div>
      </div>
    );
  };

  return (
    <div className="grid-debug-overlay">
      <div className="grid-debug-content">
        <div className="grid-debug-header">
          <h2>Grid State Debug</h2>
          <button 
            className="close-button"
            onClick={onClose}
            title="Close debug view"
          >
            ✕
          </button>
        </div>
        <div className="debug-grids-container">
          {renderGrid(previousGrid, "Before Gravity")}
          {renderGrid(currentGrid, "After Gravity")}
        </div>
      </div>
    </div>
  );
};

export default GridDebugView;

